import { Delete, Edit, ListAltOutlined } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import formatCurrency from 'utils/formatCurrency';
const columnShape = [
    {
        Header: 'Invoice Number',
        accessor: 'invoiceNumber',
        Cell: ({ row }) => {
            return (
                <>
                    <Typography variant='body2'>{row.original.invoiceNumber}</Typography>
                    <Typography variant='body2'>{row.original.sponsor}</Typography>
                </>
            );
        },
    },
    {
        Header: 'Name',
        accessor: 'fullName',
        Cell: ({ row }) => {
            return (
                <>
                    <Typography variant='body2'>{row.original.fullName}</Typography>
                    <Typography variant='body2'>{row.original.phoneNumber}</Typography>
                </>
            );
        },
    },
    {
        Header: 'Participants',
        accessor: 'details',
        Cell: ({ row }) => {
            return (
                <>
                    {row.original.details?.length > 0 ? (
                        row.original.details.map((detail) => (
                            <Box key={detail.fullName} whiteSpace={'nowrap'}>
                                <Typography variant='body2' key={detail.fullName}>
                                    {detail.fullName}
                                </Typography>
                                <Typography variant='caption' key={detail.email}>
                                    ({detail.email})
                                </Typography>
                            </Box>
                        ))
                    ) : (
                        <Typography variant='body2' color='text.disabled'>
                            -
                        </Typography>
                    )}
                </>
            );
        },
    },
    {
        Header: 'Total Amount',
        accessor: 'totalAmount',
        Cell: ({ value }) => {
            return formatCurrency(parseInt(value));
        },
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => {
            const color = value?.color || '#424242';
            const bgColor = value?.bgColor || '#eeeeee';
            const label = value?.label || value;
            return (
                <Box
                    component="span"
                    sx={{
                        display: 'inline-block',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: 12,
                        fontWeight: 500,
                        color,
                        backgroundColor: bgColor,
                    }}
                >
                    {label}
                </Box>
            );
        },
    },
    {
        Header: 'Action',
        Cell: ({ row, onClickEdit, onClickDetail, handleDelete }) => {
            const showButtonEdit =
                row.original.status === 'submitted' ||
                row.original.status === 'payment'
                    ? 'block'
                    : 'none';
            const showButtonDelete =
                localStorage.getItem('role') === 'admin' ? 'block' : 'none';
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <IconButton
                        onClick={() => onClickEdit(row.original)}
                        sx={{ display: showButtonEdit }}
                    >
                        <Tooltip title="Edit">
                            <Edit
                                sx={{
                                    color: 'text.disabled',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                    <IconButton onClick={() => onClickDetail(row.original)}>
                        <Tooltip title="Detail">
                            <ListAltOutlined
                                sx={{
                                    color: 'text.disabled',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                    <IconButton
                        onClick={() => handleDelete(row.original)}
                        sx={{ display: showButtonDelete }}
                    >
                        <Tooltip title="Delete">
                            <Delete
                                sx={{
                                    color: 'text.disabled',
                                    fontSize: 18,
                                }}
                            />
                        </Tooltip>
                    </IconButton>
                </Box>
            );
        },
    },
];
export default columnShape;
